import React, { useRef, useEffect, useState } from 'react';

const WaveInsideLockedBox = ({
  children,
  color = '#2196f3',
  backgroundColor = 'rgba(0, 0, 0, 0.4)',
  onComplete,
}) => {
  const canvasRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [targetProgress, setTargetProgress] = useState(0);
  const [holding, setHolding] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let waveOffset = 0;

    const draw = () => {
      const width = canvas.width;
      const height = canvas.height;
      const baseHeight = height * (1 - progress);
      const waveHeight = 10;

      const diff = targetProgress - progress;
      if (Math.abs(diff) > 0.001) {
        setProgress(prev => prev + diff * 0.015); // smooth slow transition
        animationFrameId = requestAnimationFrame(draw);
      } else {
        setProgress(targetProgress);
        if (targetProgress > 0.01) {
          animationFrameId = requestAnimationFrame(draw);
        } else {
          setIsAnimating(false);
        }
      }

      ctx.clearRect(0, 0, width, height);

      // Background
      ctx.fillStyle = backgroundColor;
      ctx.beginPath();
      ctx.roundRect(0, 0, width, height, 16);
      ctx.fill();

      // Draw wave only if ascending or not near bottom
      if (progress > 0.01) {
        waveOffset += 0.05;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(0, baseHeight);

        for (let x = 0; x <= width; x++) {
          const angle = (x + waveOffset * 50) * 0.05;
          const y = baseHeight + Math.sin(angle) * waveHeight;
          ctx.lineTo(x, y);
        }

        ctx.lineTo(width, height);
        ctx.lineTo(0, height);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
        ctx.restore();
      }
    };

    if (isAnimating) {
      animationFrameId = requestAnimationFrame(draw);
    }

    return () => cancelAnimationFrame(animationFrameId);
  }, [progress, targetProgress, isAnimating]);

  const handleHoldStart = () => {
    setHolding(true);
    setTargetProgress(1);
    setIsAnimating(true);
    setTimeout(() => {
      if (holding && progress >= 0.95) {
        onComplete?.();
      }
    }, 1500);
  };

  const handleHoldEnd = () => {
    setHolding(false);
    setTargetProgress(0);
    setIsAnimating(true);
  };

  return (
    <div
      className="locked-payment-box-two"
      onMouseDown={handleHoldStart}
      onMouseUp={handleHoldEnd}
      onMouseLeave={handleHoldEnd}
      onTouchStart={handleHoldStart}
      onTouchEnd={handleHoldEnd}
    >
      <canvas ref={canvasRef} className="wave-canvas" />
      <div className="wave-content">
        {children}
      </div>
    </div>
  );
};

export default WaveInsideLockedBox;
